import { Field, FieldDescription, FieldLabel } from '@eigtech/ui/components/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eigtech/ui/components/select'
import { getDeviceId } from 'amazon-chime-sdk-component-library-react'
import { AudioTransformDevice, Device, VideoTransformDevice } from 'amazon-chime-sdk-js'
import { kebabCase } from 'lodash-es'
import { useEffect, useState } from 'react'

export type DeviceType = {
  deviceId: string
  label: string
}

export type DeviceInputProps = {
  description?: string
  devices: DeviceType[]
  label: string
  notFoundMsg: string
  selectedDevice: Device | AudioTransformDevice | VideoTransformDevice | null | undefined
  onChange: (deviceId: string) => void
}

export function DeviceInput({
  description,
  devices,
  label,
  notFoundMsg,
  selectedDevice,
  onChange,
}: DeviceInputProps) {
  const [selectedDeviceId, setSelectedDeviceId] = useState<string>('')

  useEffect(() => {
    const getSelectedDeviceId = async (): Promise<void> => {
      const selectedDeviceId = await getDeviceId(selectedDevice)
      setSelectedDeviceId(selectedDeviceId)
    }

    getSelectedDeviceId()
  }, [selectedDevice])

  const deviceList = devices.map((device) => ({
    value: device.deviceId,
    label: device.label,
  }))

  const options = deviceList.length ? deviceList : [{ value: 'not-available', label: notFoundMsg }]

  const selectDevice = (deviceId: string): void => {
    if (deviceId === 'not-available') {
      return
    }
    onChange(deviceId)
  }

  return (
    <Field name={kebabCase(label)}>
      <FieldLabel>{label}</FieldLabel>

      <Select
        items={options}
        value={selectedDeviceId}
        onValueChange={(value) => value && selectDevice(value)}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>

        <SelectContent positionerClassName="z-50">
          {options.map(({ value, label }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {!!description && <FieldDescription>{description}</FieldDescription>}
    </Field>
  )
}
